import { render, staticRenderFns } from "./level.vue?vue&type=template&id=123ff2bd&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"
import style0 from "./level.vue?vue&type=style&index=0&id=123ff2bd&prod&scoped=true&lang=css"
import style1 from "./level.vue?vue&type=style&index=1&id=123ff2bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ff2bd",
  null
  
)

export default component.exports